// Type Imports
import type { Settings } from '@core/contexts/settingsContext'
import type { SystemMode } from '@core/types'

// Config Imports
import themeConfig from '@configs/themeConfig'

export const getSettingsFromStorage = (): Settings => {
  const storageName = themeConfig.settingsCookieName

  if (typeof window === 'undefined') {
    // We're on the server, return default settings
    return {}
  }

  return JSON.parse(window.localStorage.getItem(storageName) || '{}')
}

export const getMode = () => {
  if (typeof window === 'undefined') {
    return themeConfig.mode
  }

  const settingsStorage = getSettingsFromStorage()

  // Get mode from localStorage or fallback to theme config
  const _mode = settingsStorage.mode || themeConfig.mode

  return _mode
}

export const getSystemMode = (): SystemMode => {
  const mode = getMode()

  if (typeof window === 'undefined') {
    return 'light'
  }

  const colorPrefLocal = (window.localStorage.getItem('colorPref') || 'light') as SystemMode

  return (mode === 'system' ? colorPrefLocal : mode) || 'light'
}

export const getServerMode = () => {
  const mode = getMode()
  const systemMode = getSystemMode()

  return mode === 'system' ? systemMode : mode
}

export const getSkin = () => {
  if (typeof window === 'undefined') {
    return 'default'
  }

  const settingsStorage = getSettingsFromStorage()

  return settingsStorage.skin || 'default'
}
